import React, { memo } from 'react'
import { DatePicker } from 'components/forms/DatePicker'
import { RadioGroup } from 'transfix-ui/components/RadioGroup'
import { CUSTOM_START_DATE, START_TIME_OPTIONS } from 'apps/marketplace/utils/constants/rates'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'
import { formatDateForApi } from 'utils/formatDatetime'

interface IStartDateProps {
  startType: string
  startDate: string | null
  onChange: (changes: Partial<ChangeRateData>) => void
}

export const StartDate = memo<IStartDateProps>(({ onChange, startDate, startType }) => {
  const onChangeStart = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ startType: value, startDate: undefined })
  }

  const onChangeStartDate = ([date]: string[]) => {
    onChange({ startDate: date ? formatDateForApi(date) : '' })
  }
  const showStartDatePicker = startType === CUSTOM_START_DATE

  return (
    <>
      <div className='row'>
        <div className='col-md-9' data-test='set-start-date'>
          <RadioGroup
            label='Start auto-offering loads'
            name='startDateType'
            onOptionChange={onChangeStart}
            checked={startType}
            options={START_TIME_OPTIONS}
          />
        </div>
      </div>

      {showStartDatePicker && (
        <div className='row'>
          <div className='col-md-4'>
            <DatePicker
              date={startDate || ''}
              placeholder='Date'
              onDateChange={onChangeStartDate}
              dataTest='date-input-start'
              id='date-input-start'
            />
          </div>
        </div>
      )}
    </>
  )
})
